import { EquipmentTableData } from '@/equipments/application/types/EquipmentTypes';
import type { NamedEntity } from '@/raptorjob/application/utils/jobDataExtractor';
import { RaptorJobCreateForm } from './components/RaptorJobCreateForm';
import { ERPJobCreateForm } from './components/ERPJobCreateForm';
import type { RaptorJobDto } from '@/libs/api-rest/generated/model/raptorJobDto';
import type { JobFormMode } from '@/raptorjob/domain/constants/jobFormLabels';

export interface CrewField {
  rowId: string;
  employeeId: number | null;
  employeeName: string;
  roleId: number | null;
  roleName: string;
  status?: string[]; // Array of CrewAssignmentStatus values
}

export interface SelectedEquipment {
  id: EquipmentTableData['id'];
  name: EquipmentTableData['name'];
  class?: EquipmentTableData['class'] | null;
  type?: EquipmentTableData['type'] | null;
  size?: EquipmentTableData['size'] | null;
  status?: EquipmentTableData['status'] | null;
  equipmentMaxSize?: NamedEntity | null;
  defaultEmployee?: EquipmentTableData['defaultEmployee'] | null;
}

export const RaptorJobCreateModal = ({
  handleClose,
  openCreatedJob,
  isERPJob = false,
  mode,
  onSave,
  jobId,
  jobData,
  initialJobSiteId,
  initialCustomerId
}: {
  handleClose: () => void;
  openCreatedJob: (id: string) => void;
  isERPJob?: boolean;
  mode?: JobFormMode;
  onSave?: (jobId: string) => void;
  jobId?: number;
  jobData?: RaptorJobDto;
  initialJobSiteId?: number;
  initialCustomerId?: number;
}) => {
  if (isERPJob) {
    return (
      <ERPJobCreateForm
        handleClose={handleClose}
        openCreatedJob={openCreatedJob}
        mode={mode}
        onSave={onSave}
        jobId={jobId}
        jobData={jobData}
        initialJobSiteId={initialJobSiteId}
        initialCustomerId={initialCustomerId}
      />
    );
  }
  return <RaptorJobCreateForm handleClose={handleClose} openCreatedJob={openCreatedJob} />;
};
